import currencyItems from '@assets/data/currency.json';

export class CurrencyUtils {
  static getCurrencyByCode = (code: string) => {
    if (!code) return undefined;
    const item = currencyItems.find((x) => x.code.toLowerCase() == code.toLowerCase());
    return item;
  };

  static getSymbolByCode = (code?: string) => {
    if (!code) return '';
    return this.getCurrencyByCode(code)?.symbol || '';
  };

  static capitalizeByCode = (code: string) => {
    if (!code) return code;
    return code.charAt(0).toUpperCase() + code.slice(1).toLowerCase();
  };
}
